import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Box, Typography, CircularProgress, Button } from "@mui/material";
import { verifyNFCToken } from "../../services/firebase/auth"; // Changed import path

const NfcAuthHandler = () => {
  const [status, setStatus] = useState("verifying");
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const authenticateWithNFC = async () => {
      try {
        // Get token from URL query parameters
        const params = new URLSearchParams(location.search);
        const token = params.get("token");

        if (!token) {
          throw new Error("No NFC token provided");
        }

        console.log("Authenticating with NFC token:", token);

        // Verify the token with Firebase through our backend service
        const result = await verifyNFCToken(token);

        if (result.success) {
          setStatus("success");
          // Redirect to home page or dashboard after successful login
          setTimeout(() => navigate("/"), 1500);
        } else {
          throw new Error(result.error || "Invalid NFC token");
        }
      } catch (error) {
        console.error("NFC token authentication error:", error);
        setStatus("error");
        setError(error.message);
      }
    };

    authenticateWithNFC();
  }, [location, navigate]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      padding={3}
      textAlign="center"
    >
      {status === "verifying" && (
        <>
          <CircularProgress size={60} />
          <Typography variant="h5" sx={{ mt: 3 }}>
            Authenticating with NFC...
          </Typography>
        </>
      )}

      {status === "success" && (
        <>
          <Typography variant="h5" color="primary">
            Authentication Successful!
          </Typography>
          <Typography variant="body1" sx={{ mt: 2 }}>
            Redirecting to your dashboard...
          </Typography>
        </>
      )}

      {status === "error" && (
        <>
          <Typography variant="h5" color="error">
            Authentication Failed
          </Typography>
          <Typography variant="body1" sx={{ mt: 2 }}>
            {error || "There was an error authenticating with your NFC card."}
          </Typography>
          <Box sx={{ mt: 3 }}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => navigate("/signin")}
            >
              Sign In with Email
            </Button>
          </Box>
        </>
      )}
    </Box>
  );
};

export default NfcAuthHandler;
